import { useState } from "react";
import { Button, Table } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPowerOff, faTrash } from "@fortawesome/free-solid-svg-icons";

import classes from "./EntityTable.module.scss";
import ActivateModal from "./modals/ActivateModal";
import DeleteModal from "./modals/DeleteModal";

export default function EntityTable({
  entity,
  columns,
  data,
  onAddRow,
  onDeleteRow,
  onChangeStatus,
}) {
  const [isActivateModalOpen, setIsActivateModalOpen] = useState();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState();

  const [selectedEntity, setSelectedEntity] = useState();
  const [selectedEntityId, setSelectedEntityId] = useState();

  const toggleActivateModal = (driver) => {
    setIsActivateModalOpen((prev) => !prev);
    setSelectedEntity(driver);
  };

  const toggleDeleteModal = (record = {}) => {
    if (record.id && !record.deletable) return;
    setIsDeleteModalOpen((prev) => !prev);
    setSelectedEntityId(record.id);
  };

  const allColumns = [
    { title: "ID", dataIndex: "id", key: "id" },
    ...columns,
    {
      title: "Status",
      dataIndex: "active",
      key: "active",
      width: 84,
      align: "center",
      render: (active, record) => (
        <FontAwesomeIcon
          onClick={() => toggleActivateModal(record)}
          icon={faPowerOff}
          color={active ? "#016871" : "#f5ba05"}
          size="lg"
        />
      ),
    },
    {
      title: "Delete",
      dataIndex: "id",
      key: "id",
      width: 84,
      align: "center",
      render: (id, record) => (
        <FontAwesomeIcon
          onClick={() => toggleDeleteModal(record)}
          className={!record.deletable ? classes.disabled : ""}
          icon={faTrash}
          color="#f00"
          size="lg"
        />
      ),
    },
  ];

  return (
    <div className={classes.table}>
      <Button onClick={onAddRow} type="primary">
        + Add new
      </Button>
      <Table
        columns={allColumns}
        dataSource={data}
        size="middle"
        pagination={{ position: ["bottomCenter"], pageSize: 10 }}
      />
      <ActivateModal
        open={isActivateModalOpen}
        onclose={toggleActivateModal}
        active={selectedEntity?.active}
        onChangeStatus={() =>
          onChangeStatus(selectedEntity, toggleActivateModal)
        }
        entity={entity}
      />
      <DeleteModal
        open={isDeleteModalOpen}
        onclose={toggleDeleteModal}
        entity={entity}
        onDelete={() => onDeleteRow(selectedEntityId, toggleDeleteModal)}
      />
    </div>
  );
}
